var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ReleaseCom from "../../../components/releaseCom.vue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.close = function () {
        this.$refs.release.hide();
    };
    default_1.prototype.showRelease = function () {
        this.$refs.release.show({ hasMask: true, className: "release-wrapper mul-shop-release-wrapper" });
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], default_1.prototype, "listData", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], default_1.prototype, "type", void 0);
    default_1 = __decorate([
        Component({
            components: {
                'release-com': ReleaseCom
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
